export const FETCH_CHIEFDOM_LIST_REQUEST = 'FETCH_CHIEFDOM_LIST_REQUEST';
export const FETCH_CHIEFDOM_LIST_SUCCESS = 'FETCH_CHIEFDOM_LIST_SUCCESS';
export const FETCH_CHIEFDOM_LIST_FAILURE = 'FETCH_CHIEFDOM_LIST_FAILURE';
export const CLEAR_CHIEFDOM_LIST = 'CLEAR_CHIEFDOM_LIST';
